import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AvailabilityComponent } from '@app/shared/components/availability/availability-text.component';
import { MenuOverlayComponent } from '@app/shared/components/menu-overlay/menu-overlay';
import { ConfigurationViewModel } from '@models/configuration-view-model';
import { TranslatePipe } from '@ngx-translate/core';
import { DataTranslatePipe } from '@pipes/data-translate.pipe';
import { ComponentCodeConstants } from '@shared/component-constants';

@Component({
	selector: 'configuration-item',
	templateUrl: 'configuration-item.html',
	styleUrls: ['./configuration-item.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CommonModule, TranslatePipe, DataTranslatePipe, AvailabilityComponent, MenuOverlayComponent]
})
export class ConfigurationItemComponent implements OnChanges {
	@Input() conf: ConfigurationViewModel;
	@Input() image: (conf: any) => string;
	@Input() selected: boolean;
	@Input() editMode: boolean;
	@Input() variantOrModelIsNew: boolean = false;

	public componentConstants = ComponentCodeConstants;
	public showDetail: boolean = false;
	public showOverlay: boolean = false;

	ngOnChanges(changes: SimpleChanges) {
		if (changes['selected'] && !changes['selected'].firstChange && this.editMode) {
			this.showOverlay = changes['selected'].currentValue;
			new Promise(resolve => setTimeout(resolve, 2500)).then(x => {
				this.showOverlay = false;
			});
		}
	}

	showDetails() {
		this.showDetail = !this.showDetail;
	}
}
